// import Moulin from "./tours/Moulin";
import BeforeAfter from "../components/BeforeAfter";
import Preload from "../components/Preload";
import FadeIn from "../components/FadeIn";

function Product() {
    const preloadResources = {
        images: [
            {
                src: `${process.env.PUBLIC_URL}/images/art-room-before.avif`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/images/art-room-after.avif`,
                media: "(min-width: 768px)"
            },

            {
                src: `${process.env.PUBLIC_URL}/images/art-room-before-m2.avif`,
                media: "(max-width: 767px)"
            },

            {
                src: `${process.env.PUBLIC_URL}/images/art-room-after-m2.avif`,
                media: "(max-width: 767px)"
            }
        ]
    };

    return (
        <>
            <Preload {...preloadResources} />
            <title>vidi3D Product - Immersive Virtual Tours & 3D Visualization Solutions</title>
            <meta name="description" content="Discover vidi3D's comprehensive virtual tour solutions. From 3D walkthroughs to event space customization, elevate your venue presentation with our cutting-edge technology." />
            <meta name="keywords" content="virtual tours, 3D visualization, event space technology, venue presentation, virtual walkthrough" />
            <meta property="og:title" content="vidi3D Product - Immersive Virtual Tours & 3D Visualization Solutions" />
            <meta property="og:description" content="Transform your venue presentation with vidi3D's immersive virtual tours and 3D visualization solutions. Customize spaces and optimize for events." />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/art-room-after.avif`} />
            <link rel="canonical" href="https://vidi3d.com/product" />
    
        <div className="flex flex-col items-center w-full max-w-[1200px] p-4 mx-auto"> 
            <FadeIn>
                <h1 className="text-6xl font-bold text-brand text-center py-10">Elevate your space with vidi3D's immersive virtual technology</h1>
            </FadeIn>
            <FadeIn delay={0.25}>
                <p className="text-brand-dark text-center text-xl">Our virtual tours are designed to showcase your space in a way that is both engaging and informative. Whether you're looking to sell your property, showcase your business, or simply provide a unique experience for your clients, our virtual tours are the perfect solution.</p>
            </FadeIn>
            
            <BeforeAfter 
                beforeImage={{
                    desktop: `${process.env.PUBLIC_URL}/images/art-room-before.avif`,
                    mobile: `${process.env.PUBLIC_URL}/images/art-room-before-m2.avif`
                }}

                afterImage={{
                    desktop: `${process.env.PUBLIC_URL}/images/art-room-after.avif`,
                    mobile: `${process.env.PUBLIC_URL}/images/art-room-after-m2.avif`
                }}

                beforeAlt="Before" 
                afterAlt="After" 
            />
            {/* <FadeIn delay={0.25}>
                <Moulin title="try it out" />
            </FadeIn> */}
            <section className="w-full py-16">
                <FadeIn delay={0.25}>
                    <h2 className="text-6xl font-bold text-brand text-center mb-12">product onboarding</h2>
                </FadeIn>
                    <div className="grid md:grid-cols-3 gap-8">
                        {/* Step 1 */}
                        <FadeIn delay={0.4}>
                        <div className="flex flex-col items-center h-full">
                            <div className="aspect-square w-16 rounded-[50%] bg-brand flex items-center justify-center mb-6">
                                <span className="text-4xl font-bold text-white flex items-center justify-center h-full">1</span>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-lg text-center h-full">
                                <img 
                                src={`${process.env.PUBLIC_URL}/product/onboarding-1.avif`} 
                                alt="Define your brief"
                                className="w-full h-48 object-cover rounded-lg mb-4"
                                />
                                <h3 className="text-xl font-bold text-brand-dark mb-2">Define Your Brief</h3>
                                <p className="text-gray-700 mb-2">Complete our AI generated moodboard checklist and pick the styles and finish</p>
                                <p className="text-gray-700">Our interactive checklist tool makes it easy and super quick</p>
                            </div>
                        </div>
                        </FadeIn>

                        {/* Step 2 */}
                        <FadeIn delay={0.55}>
                        <div className="flex flex-col items-center h-full">
                        <div className="aspect-square w-16 rounded-[50%] bg-brand flex items-center justify-center mb-6">
                            <span className="text-4xl font-bold text-white flex items-center justify-center h-full">2</span>
                        </div>
                        <div className="bg-white p-6 rounded-lg shadow-lg text-center h-full">
                            <img 
                            src={`${process.env.PUBLIC_URL}/product/onboarding-2.avif`} 
                            alt="Share your assets"
                            className="w-full h-48 object-cover rounded-lg mb-4"
                            />
                            <h3 className="text-xl font-bold text-brand-dark mb-2">Share Your Assets</h3>
                            <p className="text-gray-700 mb-2">Easily share your assets on our cloud server</p>
                            <p className="text-gray-700">Upload your assets including: photos/videos + floorplans + dimensions</p>
                        </div>
                        </div>
                        </FadeIn>

                        {/* Step 3 */}
                        <FadeIn delay={0.7}>
                        <div className="flex flex-col items-center h-full">
                            <div className="aspect-square w-16 rounded-[50%] bg-brand flex items-center justify-center mb-6">
                                <span className="text-4xl font-bold text-white flex items-center justify-center h-full">3</span>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-lg text-center h-full">
                                <img 
                                src={`${process.env.PUBLIC_URL}/product/onboarding-3.avif`} 
                                alt="3D Design"
                                className="w-full h-48 object-cover rounded-lg mb-4"
                                />
                                <h3 className="text-xl font-bold text-brand-dark mb-2">We'll Design Your Space in 3D</h3>
                                <p className="text-gray-700 mb-2">Our team will then model your space at scale with all details</p>
                                <p className="text-gray-700">We'll share our progress to ensure your vision is respected</p>
                            </div>
                        </div>
                        </FadeIn>
                    </div>
            </section>
            <section className="w-full py-16">
                <FadeIn delay={0.25}>   
                    <h2 className="text-6xl font-bold text-brand text-center mb-12">product overview</h2>
                </FadeIn>
                <div className="flex flex-col gap-8 max-w-7xl mx-auto px-4">
                    {/* Step 4 */}
                    <FadeIn delay={0.5}>
                        <div className="flex flex-col items-center">
                            <div className="aspect-square w-16 rounded-[50%] bg-brand flex items-center justify-center mb-6">
                                <span className="text-4xl font-bold text-white flex items-center justify-center h-full">4</span>
                            </div>
                            <h3 className="text-2xl font-bold text-brand-dark mb-4">3D Walkthrough</h3>
                            <div className="bg-white p-6 rounded-lg text-center w-full">
                            <img 
                                src={`${process.env.PUBLIC_URL}/product/onboarding-4.avif`}
                                alt="3D Walkthrough" 
                                className="w-full rounded-lg"
                            />
                            </div>
                        </div>
                    </FadeIn>

                    {/* Step 5 */}
                    <FadeIn delay={0.25}>
                        <div className="flex flex-col items-center">
                            <div className="aspect-square w-16 rounded-[50%] bg-brand flex items-center justify-center mb-6">
                                <span className="text-4xl font-bold text-white flex items-center justify-center h-full">5</span>
                            </div>
                            <h3 className="text-2xl font-bold text-brand-dark mb-4">Setup Customization</h3>
                            <div className="bg-white p-6 rounded-lg text-center w-full">
                                <img 
                                src={`${process.env.PUBLIC_URL}/product/onboarding-5.avif`}
                                alt="Setup Customization"
                                className="w-full rounded-lg"
                                />
                            </div>
                        </div>
                    </FadeIn>

                    {/* Step 6 */}
                    <FadeIn delay={0.25}>
                        <div className="flex flex-col items-center">
                            <div className="aspect-square w-16 rounded-[50%] bg-brand flex items-center justify-center mb-6">
                                <span className="text-4xl font-bold text-white flex items-center justify-center h-full">6</span>
                            </div>
                            <h3 className="text-2xl font-bold text-brand-dark mb-4">Event Optimization</h3>
                            <div className="bg-white p-6 rounded-lg text-center w-full">
                                <img 
                                src={`${process.env.PUBLIC_URL}/product/onboarding-6.avif`}
                                alt="Event Optimization"
                                className="w-full rounded-lg"
                                />
                            </div>
                        </div>
                    </FadeIn>
                </div>

                {/* Step 7 - Call to Action */}
                <FadeIn delay={0.25}>
                    <div className="text-center mt-16">
                        <div className="aspect-square w-16 rounded-[50%] bg-brand flex items-center justify-center mb-6 mx-auto">
                        <span className="text-4xl font-bold text-white flex items-center justify-center h-full">7</span>
                        </div>
                        <h3 className="text-2xl font-bold text-brand-dark mb-6">Start Booking</h3>
                        <a href="/contact" className="bg-brand text-white px-8 py-4 rounded-lg text-xl font-bold hover:bg-brand-dark transition-colors duration-300">
                        Try vidi3D today
                        </a>
                    </div>
                </FadeIn>
            </section>
        </div>
        </>
    );
  }
  
  export default Product;